const $ = jQuery;

Drupal.behaviors.case_filter_submission = {
    attach: function (context, settings) {
        $('#edit-technologies', context)
            .once('edit-technologies')
            .on('change', function () {
                $('#case-selection-form', context).submit();
            });
    },
};
